import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 as uuid } from 'uuid';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { ConditionOutcome, } from '../../../powerFlowShared/components/types';
import { formatPortsHelper } from '../../../powerFlowShared/helpers/nodePortFormatter';
import { ContentModal as ActionModal } from '../modals/content';
const portTranslator = (node) => {
    return [
        {
            id: uuid(),
            type: 'out',
            label: ConditionOutcome.NO_MATCH,
            connection: node.payload.non_match_node_id || null,
        },
        {
            id: uuid(),
            type: 'out',
            label: ConditionOutcome.MATCH,
            connection: node.payload.match_node_id || null,
        },
    ];
};
const RULE_TYPES = {
    any: 'If any of the following conditions are met',
    all: 'If all of the following conditions are met',
};
export class ContentNode extends NodeTypeComponent() {
    constructor() {
        super(...arguments);
        this.triggerEdit = () => {
            const { onEdit, node } = this.props;
            onEdit(node, node.nodeType);
        };
    }
    render() {
        const { node: { payload: { rule_type, rules }, }, } = this.props;
        return (_jsx(FlowNode, { color: ContentNode.color, icon: ContentNode.icon, label: ContentNode.label, text: _jsxs("div", Object.assign({ style: { height: '32px' } }, { children: [_jsx("span", { children: RULE_TYPES[rule_type] }), _jsx("br", {}), _jsxs("strong", { children: [rules.length, " ", rules.length === 1 ? 'rule' : 'rules'] })] })), onEdit: this.triggerEdit }));
    }
}
ContentNode.icon = 'align-left';
ContentNode.label = 'Content';
ContentNode.color = flowNodeColor.purple;
ContentNode.height = FlowNode.dimensions.h + 16;
ContentNode.ActionModal = ActionModal;
ContentNode.translatePayload = formatPortsHelper(portTranslator);
ContentNode.updateConnection = (node, port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    if (port.label === ConditionOutcome.MATCH) {
        payload.match_node_id = newConnection;
    }
    if (port.label === ConditionOutcome.NO_MATCH) {
        payload.non_match_node_id = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
